import { FC } from 'react';

const Volunteering: FC = () => {
  return (
    <div>
      <h1>Hello, this is the Volunteering page</h1>
    </div>
  );
};

export default Volunteering;
